import * as React from "react";
import PropTypes from "prop-types";

import classnames from "classnames";
import styles from "./skeleton-loader.module.scss";

const DARKER = "darker";
const DARKEST = "darkest";

const SkeletonLoader = ({ width, height, circle, color, ...otherStyles }) => (
  <div
    className={classnames(
      styles.skeletonRoot,
      { [styles.circle]: circle },
      { [styles.darker]: color === DARKER },
      { [styles.darkest]: color === DARKEST }
    )}
    style={{
      width,
      height,
      ...otherStyles
    }}
  />
);

SkeletonLoader.defaultProps = {
  circle: false,
  color: "default"
};

SkeletonLoader.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  circle: PropTypes.bool,
  color: PropTypes.oneOf([DARKER, DARKEST, "default"])
};

export default SkeletonLoader;
